module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/Desktop/agoogle/src/app/canvas/canvas.component.html
// module id = ../../../../../src/app/canvas/canvas.component.html
// module chunks = main